import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { StyledWrapWidget } from './style';

/** Components */
import Error from '../Error';
import {
  StyledWidgetMini,
  StyledTitle,
  StyledWrapTitle
} from '../../../../core/WidgetMini/style';
import WeatherInfo from './WeatherInfo';
import Loading from '../../../../core/Loading';

/** API */
import { getWeather } from '../../../../../utils/apiMiniWidget';

const Weather = props => {
  const [status, setStatus] = useState(0);
  const [icon, setIcon] = useState('01d');
  const [temp, setTemp] = useState(0);
  const [tempMax, setTempMax] = useState(0);
  const [tempMin, setTempMin] = useState(0);
  const [description, setDescription] = useState('');
  const [name, setName] = useState('');
  const [lastUpdate, setLastUpdate] = useState(
    moment(new Date()).format('HH:mm')
  );

  const onGetInfoSuccess = ({ main, weather, name }) => {
    setStatus(1);
    setIcon(weather[0].icon);
    setTemp(main.temp);
    setTempMax(main.temp_max);
    setTempMin(main.temp_min);
    setDescription(weather[0].description);
    setLastUpdate(moment(new Date()).format('HH:mm'));
    setName(name);
  };

  const onGetInfoError = () => setStatus(-1);

  const getInfo = () => {
    // Set loading screen
    setStatus(0);
    // Get coords
    navigator.geolocation.getCurrentPosition(
      // onSuccess
      ({ coords }) => {
        const { latitude, longitude } = coords;
        // Get traffic info
        getWeather(latitude, longitude)
          .then(({ data }) => onGetInfoSuccess(data))
          .catch(onGetInfoError);
      },
      // onError because the user doesn't allow to know the coords
      () =>
        getWeather()
          .then(({ data }) => onGetInfoSuccess(data))
          .catch(onGetInfoError)
    );
  };

  const renderCurrentStatus = () => {
    switch (status) {
      case -1:
        return <Error />;
      case 0:
        return <Loading />;
      case 1:
        return (
          <WeatherInfo
            icon={icon}
            temp={temp}
            tempMax={tempMax}
            tempMin={tempMin}
            description={description}
            name={name}
            getWeather={getInfo}
            lastUpdate={lastUpdate}
          />
        );
      default:
        return null;
    }
  };

  const { className } = props;
  useEffect(() => {
    getInfo();
  }, []);

  return (
    <StyledWidgetMini type="weather" className={className}>
      <StyledWrapTitle className="Weather-header">
        <StyledTitle>Tiempo</StyledTitle>
      </StyledWrapTitle>
      <StyledWrapWidget>{renderCurrentStatus()}</StyledWrapWidget>
    </StyledWidgetMini>
  );
};

export default Weather;
